import React, { useState } from "react";

const Announcements = ({ header, message, publishDate }) => {
  return (
    <div className="flex-col justify-start items-center gap-2 flex ">
      <div className="px-4 py-3 w-[335px] bg-white rounded-xl border border-stone-300 justify-start items-start gap-2 inline-flex">
        <div className="flex-col justify-start items-start gap-2 inline-flex">
          <div className="justify-start items-start gap-1 inline-flex">
            <div className="text-zinc-900 text-base font-semibold font-['Open Sans'] leading-normal">
              {header}
            </div>
          </div>
          <div className="justify-start items-start inline-flex">
            <div className="text-zinc-800 text-sm font-normal font-['Open Sans'] leading-tight" style={{ whiteSpace: 'pre-line' }}>
              {message}
            </div>
          </div>
          <div className="justify-end items-end inline-flex w-[294px]">
            <div className="text-stone-500 text-sm font-normal font-['Open Sans'] leading-tight">
              {publishDate}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcements;
